// extracted by mini-css-extract-plugin
export default {"container":"exteriorb_container__XPK3Y","text":"exteriorb_text__mvTFa","info":"exteriorb_info__B7PeT"};